import * as yup from 'yup';

export const step1Schema = yup.object({
  templateId: yup.string().required('Please select a template'),
});

export const step2Schema = yup.object({
  instanceName: yup.string().required('Instance name is required'),
  deadlineDate: yup.date().required('Deadline date is required').nullable(),
  deadlineTime: yup.string().required('Deadline time is required'),
  reminderDate: yup
    .date()
    .required('Reminder date is required')
    .nullable()
    .test('is-before-deadline', 'Reminder cannot be later than the deadline', function validate(value) {
      const { deadlineDate, deadlineTime, reminderTime } = this.parent;
      if (!deadlineDate || !deadlineTime || !value || !reminderTime) {
        return true; // Let required validators handle empty fields
      }

      // Construct dates for comparison
      // Helper to extract date string YYYY-MM-DD
      const getDateStr = (d: any) => {
        if (d instanceof Date) {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        if (typeof d === 'string' && d.includes('T')) return d.split('T')[0];
        return d;
      };

      const dDate = getDateStr(deadlineDate);
      const rDate = getDateStr(value);

      const deadline = new Date(`${dDate}T${deadlineTime}`);
      const reminder = new Date(`${rDate}T${reminderTime}`);

      return reminder <= deadline;
    }),
  reminderTime: yup.string().required('Reminder time is required'),
});

export const step3Schema = yup.object({
  selectedAssets: yup.array().min(1, 'Please select at least one asset').required('Assets are required'),
});

const actionLibraryInstanceValidationSchema = [step1Schema, step2Schema, step3Schema];

export default actionLibraryInstanceValidationSchema;
